<template>
  <div class="content">
    <div>
      <label>{{ __("Property type") }}:</label>
      <span>{{ __(apartment.UTypeName) }}</span>
      <label>{{ __("rooms number") }}:</label>
      <span>{{ apartment.RoomsNum }}</span>
      <label>{{ __("Storage") }}:</label>
      <span>{{ apartment.Storage != "0" ? __("Yes") : __("No") }}</span>
      <label>{{ __("Management type") }}:</label>
      <span>{{ __(apartment.ManagementTypeName) }}</span>
      <label>{{ __("Payment methods") }}:</label>
      <span>{{ __(apartment.PaymentTypeName) }}</span>
      <label>{{ __("Apartment debt") }}:</label>
      <span>
        {{ apartment.HovUnit }}
        <p-vue-button
          v-if="+apartment.HovUnit != 0"
          class="button--show p-button-sm p-button-outlined p-button-rounded p-button-success"
          @click="showHov(apartment)"
        >
          {{ __("Show") }}
        </p-vue-button>
      </span>
    </div>
    <div>
      <label>{{ __("Floor") }}:</label>
      <span>{{ apartment.Floor }}</span>
      <label>{{ __("Area") }}:</label>
      <div
        v-html="__u_value__({ value: apartment.Size, unit: 'square-meter' })"
      ></div>
      <label>{{ __("Warehouse space") }}:</label>
      <div
        v-html="__u_value__({ value: apartment.Storage, unit: 'square-meter' })"
      ></div>
      <label>{{ __("House committee") }}:</label>
      <p-vue-checkbox
        v-model="apartment.IsInVaad"
        :binary="true"
        :disabled="true"
      />
      <label>{{ __("Legal") }}:</label>
      <p-vue-checkbox
        v-model="apartment.IsLegal"
        :binary="true"
        :disabled="true"
      />
    </div>
  </div>
  <div class="p-d-flex p-jc-end">
    <div class="editBtn" @click="editUnit">
      <i-icon name="pen" />
    </div>
  </div>
  <p-vue-table
    v-if="apartment.ownerContact?.length > 0"
    :value="apartment.ownerContact"
    v-model:expandedRows="ownerExpandedRows"
    responsiveLayout="scroll"
    class="p-no-thead"
  >
    <p-vue-column
      field="type"
      :style="{
        width: '15%',
      }"
    >
      <template #body="{ data }">
        <label v-if="data.type">{{ __(data.type) }}:</label>
      </template>
    </p-vue-column>
    <p-vue-column
      :style="{
        width: '85%',
      }"
      ><template #body="{ data }">
        <label>{{ data.FirstName }} {{ data.LastName }}</label>
      </template></p-vue-column
    >
    <p-vue-column field="contacts">
      <template #body="{ data }">
        <div class="p-d-flex ">
          <i-contacts-group
            :data="{
              mail: data.Email,
              phone: data.TelMobile,
              whatsapp: data.TelMobile,
            }"
            :showEditBtn="true"
            :showArrowBtn="true"
            :contact="data"
            @editContact="editContact"
            @showContact="showContact"
          />
        </div>
      </template>
    </p-vue-column>
    <template #expansion="{ data }">
      <div class="grid p-my-2 p-mr-6">
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Mobile") }}:</label>
          <span>{{ __(data.TelMobile) }}</span>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Mobile") }} 2:</label>
          <span>{{ __(data.TelMobile2) }}</span>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Email") }}:</label>
          <span>{{ __(data.Email) }}</span>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Email") }} 2:</label>
          <span>{{ __(data.Email2) }}</span>
        </div>
      </div>
    </template>
  </p-vue-table>
  <p-vue-table
    v-if="apartment.renterContact?.length > 0"
    :value="apartment.renterContact"
    v-model:expandedRows="renterExpandedRows"
    responsiveLayout="scroll"
    class="p-no-thead"
  >
    <p-vue-column
      field="type"
      :style="{
        width: '15%',
      }"
    >
      <template #body="{ data }">
        <label v-if="data.type">{{ __(data.type) }}:</label>
      </template>
    </p-vue-column>
    <p-vue-column
      :style="{
        width: '85%',
      }"
      ><template #body="{ data }">
        <label>{{ data.FirstName }} {{ data.LastName }}</label>
      </template></p-vue-column
    >
    <p-vue-column field="contacts">
      <template #body="{ data }">
        <i-contacts-group
          :data="{
            mail: data.Email,
            phone: data.TelMobile,
            whatsapp: data.TelMobile,
          }"
          :showEditBtn="true"
          :showArrowBtn="true"
          :contact="data"
          @editContact="editContact"
          @showContact="showContact"
        />
      </template>
    </p-vue-column>
    <template #expansion="{ data }">
      <div class="grid p-my-2 p-mr-6">
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Mobile") }}:</label>
          <span>{{ __(data.TelMobile) }}</span>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Mobile") }} 2:</label>
          <span>{{ __(data.TelMobile2) }}</span>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Email") }}:</label>
          <span>{{ __(data.Email) }}</span>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <label>{{ __("Email") }} 2:</label>
          <span>{{ __(data.Email2) }}</span>
        </div>
      </div>
    </template>
  </p-vue-table>

  <i-override-dialog
    v-model:visible="showModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="modalTitle"
  >
    <p-edit-apartment
      v-if="dataToEdit.Number"
      :apartment="dataToEdit"
      :close="
        () => {
          showModal = false;
        }
      "
    ></p-edit-apartment>
    <p-edit-contact
      v-if="dataToEdit.ContactID"
      :contact="dataToEdit"
      :close="
        () => {
          showModal = false;
        }
      "
      @ContactUpdate="ContactUpdate"
    ></p-edit-contact>
  </i-override-dialog>
</template>

<script>
import PEditApartment from "@/components/partials/p-edit-apartment";
import PEditContact from "@/components/partials/p-edit-contact";
import { __ } from "@/plugins/i18n";
export default {
  components: {
    PEditApartment,
    PEditContact,
  },
  props: ["apartmentData"],
  data() {
    return {
      apartment: {},
      showModal: false,
      modalTitle: null,
      dataToEdit: {},
      ownerExpandedRows: [],
      renterExpandedRows: [],
    };
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.apartment = this.apartmentData;
    },
    showHov(myApartment) {
      // console.log(myApartment);
      this.$store.commit("setApartmentSelected", myApartment);
      var contactId = 0;
      if (myApartment.renterContact?.length > 0)
        contactId = myApartment.renterContact[0].ContactID;
      else if (myApartment.ownerContact?.length > 0)
        contactId = myApartment.ownerContact[0].ContactID;
      if (contactId > 0) this.$router.push("/financial-report/" + contactId);
      else this.$router.push("/financial-report/");
    },
    editContact(contact) {
      this.dataToEdit = contact;
      this.showModal = true;
      this.modalTitle = __("Edit a") + " " + this.dataToEdit.FirstName;
    },
    showContact(contact) {
      let Expanded = contact.Expanded;
      this.ownerExpandedRows = [];
      this.renterExpandedRows = [];
      this.apartment.ownerContact.forEach((c) => (c.Expanded = false));
      this.apartment.renterContact.forEach((c) => (c.Expanded = false));
      if (Expanded) contact.Expanded = false;
      else {
        if (contact.contactType == 1) this.ownerExpandedRows.push(contact);
        else if (contact.contactType == 2)
          this.renterExpandedRows.push(contact);
        contact.Expanded = true;
      }
    },
    editUnit() {
      this.dataToEdit = this.apartment;
      this.showModal = true;
      this.modalTitle = __("Edit a") + " " + this.dataToEdit.name;
    },
  },
  watch: {
    apartmentData() {
      this.setData();
    },
  },
};
</script>

<style scoped>
.button--show {
  padding: 0 12px;
  margin-right: 5px;

  color: var(--color-success-active) !important;
}

.filter {
  display: flex;
  justify-content: space-between;

  padding: 10px 15px 5px;

  background-color: var(--color-primary);
}

.filter a {
  color: white;

  margin-right: 3px;
}

.filter a:deep(.svg) {
  width: 24px;
  height: 24px;
}

.editBtn {
  color: var(--color-success);
  border: 1px solid var(--color-success);
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -30px 0px 10px 10px;
}

.editBtn:deep(.svg) {
  width: 15px;
  height: 20px;
}

.search {
  flex: 1;

  padding: 0 0 8px 0;

  border-radius: 0;
  border: 1px solid white;
  border-width: 0 0 1px 0;
  background-color: transparent;

  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.search::placeholder {
  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.toggler {
  flex: 0 0 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px 15px;

  color: inherit;
  text-decoration: none;
}

.content {
  display: grid;
  align-items: flex-start;
  justify-content: space-between;
  grid-template-columns: auto auto;

  border-top: 1px solid white;

  padding: 20px 0 15px;
}

.content > div {
  gap: 20px 5px;
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;

  font-size: 14px;
  color: #080808;
  line-height: 1.46;
  font-weight: normal;
  letter-spacing: 0.45px;
}

.content > div span {
  display: flex;
  align-items: center;
}

:deep(label) {
  color: var(--color-primary-hover);
}

.content ul {
  margin: 0;
  padding: 0;

  list-style: none;
}

.content ul li {
  gap: 15px;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}

.p-panel {
  border-bottom: 1px solid var(--color-border-alt);
}

.p-panel:deep(.p-panel-content) {
  padding: 0 15px;

  border: none;
}

.p-panel:deep(.p-panel-header) {
  padding: 0px;
}

.p-panel:deep(.p-panel-header .svg) {
  width: 15px;
  height: 15px;

  color: var(--color-success);

  transform: rotate(180deg);

  transition: transform 0.3s ease;
}

.name {
  margin: 0;

  color: black;
  font-size: 16px;
  line-height: 1.28;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.panels:deep(.p-panel.p-panel-collapsed .name) {
  color: var(--color-label);
}

.panels:deep(.p-panel.p-panel-collapsed .svg) {
  transform: rotate(0deg);
}

:deep(.p-datatable) {
  padding-top: 7px;
  padding-bottom: 7px;

  border-top-color: var(--color-border);
}

:deep(.p-datatable tr) {
  background: transparent;
}

:deep(.p-datatable tr td) {
  padding: 5px 0;

  border: none;
}

.edit-button {
  width: 20px;
  height: 20px;
}

.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
}
</style>
